// Thin fetch wrapper for the survey endpoints. Types come from @fsl/shared —
// the same zod schemas the server validates with, so client and server can't
// disagree on shape.

import type {
  SurveySignupInput,
  SurveyUpdateInput,
} from "@fsl/shared/schemas";

export class ApiError extends Error {
  constructor(public readonly status: number, public readonly body: unknown) {
    super(`API ${status}`);
  }
}

async function request<T>(method: string, url: string, body?: unknown): Promise<T> {
  const init: RequestInit = { method };
  if (body !== undefined) {
    init.headers = { "content-type": "application/json" };
    init.body = JSON.stringify(body);
  }
  const res = await fetch(url, init);
  if (!res.ok) {
    const errorBody = await res.json().catch(() => ({}));
    throw new ApiError(res.status, errorBody);
  }
  return (await res.json()) as T;
}

export const surveyApi = {
  signup: (input: SurveySignupInput) =>
    request<{ id: string }>("POST", "/v1/survey", input),
  update: (id: string, input: SurveyUpdateInput) =>
    request<{ ok: true }>("PATCH", `/v1/survey/${id}`, input),
};
